import { createGlobalStyle } from 'styled-components';
import {
  FellixBlack,
  FellixExtraBold,
  FellixBold,
  FellixSemiBold,
  FellixMedium,
  FellixRegular,
  FellixLight,
  FellixThin,
  FellixBlackItalic,
  FellixExtraBoldItalic,
  FellixBoldItalic,
  FellixSemiBoldItalic,
  FellixMediumItalic,
  FellixRegularItalic,
  FellixLightItalic,
  FellixThinItalic,
} from '../fonts';
import screens from './screens';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixBlack}) format("opentype");
    font-weight: 900;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixExtraBold}) format("opentype");
    font-weight: 800;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixBold}) format("opentype");
    font-weight: 700;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixSemiBold}) format("opentype");
    font-weight: 600;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixMedium}) format("opentype");
    font-weight: 500;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixRegular}) format("opentype");
    font-weight: 400;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixLight}) format("opentype");
    font-weight: 300;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixThin}) format("opentype");
    font-weight: 100;
    font-style: normal;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixBlackItalic}) format("opentype");
    font-weight: 900;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixExtraBoldItalic}) format("opentype");
    font-weight: 800;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixBoldItalic}) format("opentype");
    font-weight: 700;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixSemiBoldItalic}) format("opentype");
    font-weight: 600;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixMediumItalic}) format("opentype");
    font-weight: 500;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixRegularItalic}) format("opentype");
    font-weight: 400;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixLightItalic}) format("opentype");
    font-weight: 300;
    font-style: italic;
  };
  @font-face {
    font-family: 'Fellix';
    src: url(${FellixThinItalic}) format("opentype");
    font-weight: 100;
    font-style: italic;
  };
  body {
    background: radial-gradient(circle, rgba(1,33,105,1) 0%, rgba(1,17,53,1) 100%);
    font-family: 'Fellix', sans-serif;
    font-weight: 500;
    color: white;
    margin: 0;
    overflow-x: hidden;
    max-width: 100vw;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  hr {
    border: 0;
  }

  input {
    font-family: 'Fellix', sans-serif;
  }

  button {
    font-family: 'Fellix', sans-serif;
  }

  #gatsby-focus-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .swiper {
    position: absolute !important;

    .swiper-wrapper {
      margin-top: 20px;
      max-width: calc(100vw);

      @media ${screens.laptop} {
        max-width: calc(100vw - 1.5rem);
        margin-top: 50px;
      }

      .swiper-slide {
        width: max-content !important;
          &:first-child {
            margin-left: 1.5rem;
          }
      }
    }
  }
  `;

export default GlobalStyle;
